var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 177,
    viewBox: "0 0 194 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.687 51.9133V120.64C183.687 148.207 142.567 170.554 91.8442 170.554C41.121 170.554 0 148.207 0 120.64V51.9133",
    fill: "#F9F1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8442 2C41.1199 2 0 24.3466 0 51.9133C0 61.4705 4.95026 70.3972 13.521 77.9854C13.5151 89.8332 13.4482 120.058 13.5574 119.984C13.5292 131.695 31.4132 131.327 31.4566 119.983C31.4566 119.983 31.4566 102.987 31.4566 89.5045C33.147 90.3076 34.8786 91.0848 36.6747 91.8186C36.6653 99.8859 36.6677 107.66 36.7323 107.614C36.7041 119.324 54.588 118.957 54.6315 107.613C54.6315 107.613 54.6315 103.18 54.6315 97.5447C66.0086 100.29 78.5922 101.827 91.8419 101.827C142.566 101.827 183.685 79.48 183.685 51.9133C183.685 24.3466 142.567 2 91.8442 2Z",
    fill: "#F9F1E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.165 54.2979C99.8617 54.2979 105.29 48.872 105.29 42.1789C105.29 35.4857 99.8617 30.0598 93.165 30.0598C86.4683 30.0598 81.0396 35.4857 81.0396 42.1789C81.0396 48.872 86.4683 54.2979 93.165 54.2979Z",
    fill: "#FFAE9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.658 53.1824V123.657C191.658 151.924 149.492 174.839 97.4796 174.839C45.4668 174.839 3.30029 151.924 3.30029 123.657V53.1824",
    stroke: "#FF7B72",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4796 2C45.4656 2 3.30029 24.9148 3.30029 53.1824C3.30029 62.9825 8.37642 72.1361 17.1651 79.9173C17.1591 92.0663 17.0904 123.06 17.2024 122.984C17.1735 134.992 35.5121 134.615 35.5567 122.983C35.5567 122.983 35.5567 105.554 35.5567 91.7292C37.2901 92.5527 39.0656 93.3498 40.9075 94.1022C40.8978 102.375 40.9002 110.346 40.9665 110.299C40.9376 122.307 59.2762 121.93 59.3207 110.298C59.3207 110.298 59.3207 105.753 59.3207 99.9739C70.9872 102.789 83.8907 104.365 97.4772 104.365C149.491 104.365 191.655 81.4499 191.655 53.1824C191.655 24.9148 149.492 2 97.4796 2Z",
    stroke: "#FF7B72",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8336 55.6263C105.701 55.6263 111.267 50.0625 111.267 43.1992C111.267 36.3358 105.701 30.772 98.8336 30.772C91.9667 30.772 86.3999 36.3358 86.3999 43.1992C86.3999 50.0625 91.9667 55.6263 98.8336 55.6263Z",
    stroke: "#FF7B72",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/NoResult.52e32c2ef660a54e673880f5e18a2a5c.svg";
export { ForwardRef as ReactComponent };